import { environment } from '../../environments/environment';
import { canonicalAppVersion } from './technical-identifiers';

export interface AuthUiRuntimeConfig {
  apiUrl: string;
  observabilityUrl: string;
  clientApp: string;
  release: string;
  environmentName: string;
  sentryDsn: string;
  telemetryEnabled: boolean;
}

interface RuntimeConfigInput {
  apiUrl?: unknown;
  observabilityUrl?: unknown;
  clientApp?: unknown;
  release?: unknown;
  environmentName?: unknown;
  sentryDsn?: unknown;
  telemetryEnabled?: unknown;
}

export interface ClientTelemetryBridge {
  attach(reporter: (event: unknown) => void): void;
  report(event: unknown): boolean;
  context?: {
    flowId: string;
    deviceId: string;
  };
}

declare global {
  interface Window {
    __AUTH_UI_CONFIG__?: RuntimeConfigInput;
    __AUTH_UI_STARTUP_STALLED__?: boolean;
    __reforceObservability?: ClientTelemetryBridge;
  }
}

const input = window.__AUTH_UI_CONFIG__ ?? {};

function text(value: unknown, fallback: string): string {
  return typeof value === 'string' ? value : fallback;
}

function withoutTrailingSlash(value: string): string {
  return value.length > 1 ? value.replace(/\/+$/, '') : value;
}

export const runtimeConfig: Readonly<AuthUiRuntimeConfig> = Object.freeze({
  // An explicitly configured empty API URL means same-origin requests.
  apiUrl: withoutTrailingSlash(text(input.apiUrl, environment.apiUrl)),
  observabilityUrl: text(input.observabilityUrl, environment.observabilityUrl),
  clientApp: text(input.clientApp, environment.clientApp),
  release: canonicalAppVersion(text(input.release, environment.release)) ?? 'unknown',
  environmentName: text(input.environmentName, environment.environmentName),
  sentryDsn: text(input.sentryDsn, environment.sentryDsn),
  telemetryEnabled:
    typeof input.telemetryEnabled === 'boolean'
      ? input.telemetryEnabled
      : environment.telemetryEnabled,
});
